import { render, staticRenderFns } from "./SliderBlock.vue?vue&type=template&id=1ff7f762&"
import script from "./SliderBlock.vue?vue&type=script&lang=js&"
export * from "./SliderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default,UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
